import React, { useState } from "react";
import { FileDown, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "@/lib/api";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

// End-of-day PDF: scanner entries and their move till 12:00 / 14:00 / 15:00
export const DayReports = () => {
  const [days, setDays] = useState(null);
  const [busy, setBusy] = useState(null);
  const loadDays = (open) => open && api.get("/reports/days").then((r) => setDays(r.data.days)).catch(() => setDays([]));
  const monday = (d) => { const x = new Date(`${d}T00:00:00Z`); x.setUTCDate(x.getUTCDate() - ((x.getUTCDay() + 6) % 7)); return x.toISOString().slice(0, 10); };
  const weeks = [...new Set((days || []).map(monday))];
  const download = async (day, kind = "day") => {
    const key = `${kind}-${day}`;
    setBusy(key);
    try {
      const r = await api.get(`/reports/${kind}/${day}`, { responseType: "blob" });
      const url = URL.createObjectURL(r.data);
      const a = Object.assign(document.createElement("a"), { href: url, download: `TFR-${kind === "week" ? "Weekly" : "Day"}-Report-${day}.pdf` });
      a.click();
      URL.revokeObjectURL(url);
    } catch {
      toast.error("Could not build that report");
    }
    setBusy(null);
  };
  return (
    <DropdownMenu onOpenChange={loadDays}>
      <DropdownMenuTrigger asChild>
        <button className="flex items-center gap-1.5 text-[11px] font-mono px-2.5 py-1 rounded-full border border-slate-300 text-slate-700 hover:border-blue-500 hover:text-blue-700 transition-colors" data-testid="day-reports-btn">
          <FileDown className="h-3 w-3" /> Day report PDF
        </button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-52" data-testid="day-reports-menu">
        <DropdownMenuLabel className="text-[10px] font-mono text-slate-500">Scanner entries · move till 12, 2 & 3 PM</DropdownMenuLabel>
        {days === null && <div className="px-2 py-1.5 text-xs text-slate-500">Loading…</div>}
        {days?.length === 0 && <div className="px-2 py-1.5 text-xs text-slate-500" data-testid="day-reports-empty">No reports yet — the first one builds during today's session</div>}
        {days?.map((d) => (
          <DropdownMenuItem key={d} onSelect={(e) => { e.preventDefault(); download(d); }} className="font-mono text-xs" data-testid={`day-report-${d}`}>
            {busy === `day-${d}` ? <Loader2 className="mr-2 h-3 w-3 animate-spin" /> : <FileDown className="mr-2 h-3 w-3" />}{d}
          </DropdownMenuItem>
        ))}
        {weeks.length > 0 && <DropdownMenuLabel className="text-[10px] font-mono text-slate-500 border-t border-slate-100 mt-1">Weekly comparison</DropdownMenuLabel>}
        {weeks.map((w) => (
          <DropdownMenuItem key={w} onSelect={(e) => { e.preventDefault(); download(w, "week"); }} className="font-mono text-xs" data-testid={`week-report-${w}`}>
            {busy === `week-${w}` ? <Loader2 className="mr-2 h-3 w-3 animate-spin" /> : <FileDown className="mr-2 h-3 w-3" />}Week of {w}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
